export default __webpack_public_path__ + "static/media/p32.af0010d5.JPG";